import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { userMaster } = stateEnum

const initialState = { 
  selectedUser: {},
} 

const userMasterSlice = createSlice({
  name: userMaster,
  initialState,
  reducers: {
    resetUserMaster: (state) => {
      state.selectedUser = {}
    },
    setCurrentUser: (state, action) => {
      state.selectedUser = action.payload
    },
  }, 
})

export const { resetUserMaster, setCurrentUser } = userMasterSlice.actions
export default userMasterSlice.reducer
